import React from "react";
import { Box, Typography, Grid, Link, useTheme, useMediaQuery } from "@mui/material";
import { IMG_DAINASOUL_IMG1, IMG_DAINASOUL_IMG2 } from "./imageConfig";

const FeaturedEdits = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const edits = [
    {
      title: "",
      description: "",
      image: IMG_DAINASOUL_IMG1,
      link: "/products/ready-to-wear"
    },
    {
      title: "DAINASOUL Classics",
      description: "Discover our timeless DAINASOUL Collection classics and choose your personal favorite.",
      image: IMG_DAINASOUL_IMG2,
      link: "/products/timeless-classics"
    }
  ];

  return (
    <Box sx={{ mt: { xs: 8, md: 10 }, mb: { xs: 8, md: 10 }, px: 0 }}>
      {/* Section Title */}
      <Typography
        variant="h4"
        sx={{
          fontFamily: '"Playfair Display", serif',
          fontSize: { xs: "30px", md: "36px" },
          mb: 5,
          pl: { xs: 2, md: 4 },
          fontWeight: 400,
          color: "#000",
        }}
      >
        Featured Edits
      </Typography>

      <Grid container spacing={isMobile ? 2 : 2}>
        {edits.map((edit, index) => (
          <Grid item xs={12} md={6} key={index}>
            <Box 
              sx={{ 
                display: "flex", 
                flexDirection: "column",
                cursor: "pointer",
                "&:hover img": {
                  opacity: 0.9
                }
              }}
            >
              {/* Image Container */}
              <Box
                component="img"
                src={edit.image}
                alt={edit.title}
                sx={{
                  width: "100%",
                  height: { xs: "480px", md: "720px" },
                  objectFit: "cover",
                  mb: 2.5,
                  transition: "opacity 0.3s ease",
                }}
              />
              
              {/* Text Content */}
              {edit.title && (
                <Box sx={{ px: { xs: 2 } }}>
                  <Typography
                    variant="h5"
                    sx={{
                      fontFamily: '"Playfair Display", serif',
                      fontSize: "19px",
                      fontWeight: 600,
                      mb: 1,
                      color: "#000",
                    }}
                  >
                    {edit.title}
                  </Typography>
                  
                  <Typography
                    variant="body2"
                    sx={{
                      color: "#444",
                      fontSize: "13px",
                      mb: 2.5,
                      maxWidth: { xs: "100%", md: "90%" },
                      lineHeight: 1.6,
                      fontFamily: "inherit",
                    }}
                  >
                    {edit.description}
                  </Typography>
                  
                  <Link
                    href={edit.link}
                    sx={{
                      color: "#000",
                      fontSize: "11px",
                      fontWeight: 700,
                      textTransform: "uppercase",
                      textDecoration: "none",
                      borderBottom: "1px solid #000",
                      width: "fit-content",
                      letterSpacing: "1px",
                      pb: "2px",
                      "&:hover": {
                        color: "#666",
                        borderColor: "#666",
                      }
                    }}
                  >
                    SHOP EDIT
                  </Link>
                </Box>
              )}
            </Box>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default FeaturedEdits;
